import AdminPanel from "./AdminPanel";

function App() {
  return (
    <div className="App">
      <AdminPanel />
    </div>
  );
}

export default App;
